import { type GetHookResponse } from '../hooks'
import { webhooksKey } from '../keys'
import { useTantalimQuery } from '../query'
import { type WebhookListInput, type WebhookListSuccess, type WebhookData } from '@terros/common'

export function useWebhooks(): GetHookResponse<WebhookData[]> {
  return useTantalimQuery<WebhookListInput, WebhookListSuccess, WebhookData[]>({
    url: '/webhook/list',
    queryKey: webhooksKey(),
    input: {},
    convertResponse: (data) => {
      return data.webhooks
    },
  })
}
